import React from 'react';
import styles from './Footer.module.scss';

export const SocialLink = ({ name, iconSrc }) => {
  return (
    <div className={styles.socialItem}>
      <div className={styles.socialContent}>
        <div className={styles.socialText}>{name}</div>
        <img
          loading="lazy"
          src={iconSrc}
          alt={`${name} social media icon`}
          className={styles.socialIcon}
        />
      </div>
    </div>
  );
};